import React, { useEffect, useState } from "react";
import { countdown } from "../lib/format";

export default function Countdown({ iso, size = "md", testid = "countdown" }) {
  const [t, setT] = useState(() => countdown(iso));
  useEffect(() => {
    if (!iso) return;
    const i = setInterval(() => setT(countdown(iso)), 1000);
    return () => clearInterval(i);
  }, [iso]);

  const cls = size === "lg" ? "text-5xl md:text-6xl" : size === "sm" ? "text-lg" : "text-3xl";
  const lbl = size === "lg" ? "text-[10px]" : "text-[9px]";
  const gap = size === "lg" ? "gap-4 md:gap-6" : "gap-3";

  if (!t.valid) return <span className="sat-label" data-testid={testid}>TBD</span>;
  const sign = t.past ? "T+" : "T-";
  const items = [
    { k: "d", v: t.d, l: "DAYS" },
    { k: "h", v: t.h, l: "HRS" },
    { k: "m", v: t.m, l: "MIN" },
    { k: "s", v: t.s, l: "SEC" },
  ];
  return (
    <div className={`flex items-baseline ${gap} font-mono`} data-testid={testid}>
      <span className={`${cls} sat-cyan sat-glow font-bold`}>{sign}</span>
      {items.map(({ k, v, l }) => (
        <div key={k} className="text-center">
          <div className={`${cls} sat-cyan sat-glow font-bold tabular-nums leading-none`} data-testid={`${testid}-${k}`}>
            {String(v).padStart(2, "0")}
          </div>
          <div className={`sat-label ${lbl} mt-1 md:mt-2`}>{l}</div>
        </div>
      ))}
    </div>
  );
}
